import React, { Component, Fragment } from 'react';
import Option from "./option";
import getLabel from './../../../utils/labels'
import { userInfo } from 'os';

class MCQ extends Component {
    state = {
        userOption: null,
        showError: false
    };
    userClickedOnOption = (userOption) => {
        this.setState({
            userOption,
            showError: false
        });
        if (this.props.tutorial.isRunning) {
            this.goToNextTutorialStep();
        }
    }

    goToNextTutorialStep = () => {
        this.props.updateStepNumber(this.props.tutorial.stepIndex + 1);
    }

    userClickedOnSubmit = () => {
        if (!this.state.userOption) {
            this.setState({
                showError: true
            })
        }
        this.props.userClickedOnSubmit(this.props.id, this.state.userOption);
    }
    render() {
        const { text, options, id, userOptionId } = this.props;
        let ele;
        if (!userOptionId) {
            ele = options.map((option, i) => {
                return <Option {...option} userClickedOnOption={this.userClickedOnOption} key={i} index={i} userOption={this.state.userOption} />
            })
        } else {
            const opt = options.find((op) => op.id === userOptionId);
            ele = <Option {...opt} />
        }
        return (
            <div className="chat-text">
                {userOptionId && ele}
                {!userOptionId &&
                    <Fragment>
                        <div className="question-title">{text}</div>
                        <div className="mcq-wrap">
                            <div>
                                {ele}
                            </div>
                        </div>
                    </Fragment>
                }
                {!userOptionId && <div onClick={() => {
                    this.userClickedOnSubmit();
                }} className="chat-reply-button">{getLabel('label_reply_button')}</div>}
                {this.state.showError && <div className="chat-reply-button-error">{getLabel('label_select_option_text')}</div>}
            </div>

        );
    }
}

export default MCQ;



// WEBPACK FOOTER //
// /src/call/container/mcq/mcq.js